module.exports = __webpack_public_path__ + "assets/img/06f75f84c3f23a89193941a1abea086a.png";